<script lang="ts">
import { AppModal } from "./app-modal.ts";
export default AppModal;
</script>

<template>
    <div class="modal" v-if="$props.visible">
        <div class="modal__overlay" @click="closeModal" />
        <div class="modal__dialog" :style="{ maxWidth: $props.maxWidth || '440px' }">
            <img src="/img/close-btn.svg" class="modal__close" @click="closeModal" />
            <div class="modal__content">
                <slot name="content"></slot>
            </div>
            <div
                class="modal__footer"
                :class="{ 'modal__footer--center': !$props.visibleCancelBtn }"
                v-if="$props.visibleFooter"
            >
                <div
                    class="modal__button modal__button--outline"
                    @click="cancel"
                    v-if="$props.visibleCancelBtn"
                >
                    <i18n-t :keypath="$props.cancelButtonText" />
                </div>
                <div
                    class="modal__button modal__button--red"
                    @click="submit"
                    v-if="$props.submitButtonIsRed"
                >
                    <i18n-t :keypath="$props.submitButtonText" />
                </div>
                <div class="modal__button modal__button--blue" @click="submit" v-else>
                    <i18n-t :keypath="$props.submitButtonText" />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import "./app-modal";
</style>
